import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { SecurityService } from './security.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGaurdService implements CanActivate {

  constructor(private readonly authService: AuthenticationService,private securityService:SecurityService,private router:Router) {
    console.log("auth guard service    ");
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log("auth guard service: started ");
    let canAccess:boolean=false;
    this.authService.enableSilentRenew();
    if(this.securityService.isUserAuthorized){
      const userRoles= route.data['roles'];
      if(userRoles){
        for(const roleName of userRoles) {
          if (this.securityService.LOGGED_USER.roleName?.toLowerCase().includes(roleName.toString().toLowerCase())) {
            canAccess= true;
            break;
          }
        }
      }
    }
    if(!canAccess){
      this.router.navigateByUrl("/home");
    }
    return canAccess;
  }
}

